/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { ProductCard } from "../../components";
// import { FilterBar } from "./components/FilterBar";
import {  useSearch } from "../../store/context/SearchContext.jsx"
// import { useLocation } from "react-router-dom";
// import { useFilter } from "../../store/context/FilterContext.jsx";

export const ProductsList = () => {
  // const {productsList} = useFilter()
  const [show, setShow] = useState(false);
  const [allProducts, setAllProducts] = useState([]);
  // const [xataData, setXataData] = useState([]);
  const [ CmsData, setCmsData] = useState([]);
  const { searchTearm  } = useSearch()
  

  // const searchLocation = useLocation().search

console.log("productsList Array", )

 
   const getFeaturedProductsCms = async () => {
   

 // const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_LOCAL}/api/products?populate[poster][populate]=*`)
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/products?populate[poster][populate]=*`)
    const data = await response.json()
    console.log("getFeaturedProducts", data)
    setAllProducts(data.data)
    setCmsData(data.data)
   }
   
  useEffect(() => {
   async function getProducts(){
    let searchFor;
    if(searchTearm){
      searchFor = "get_searched_products"
    }else{
      searchFor = "get_products"
    }
      //-------------------------------------------------------------------------------------
// const get_products_netlify_serverless = await fetch("/.netlify/functions/getProducts" , {
//   method: "POST" , 
//   body: JSON.stringify({
//     request_type: searchFor,
//     searchTearm : searchTearm ,
//   })
// })
getFeaturedProductsCms()

// const data = await get_products_netlify_serverless.json()
// if(get_products_netlify_serverless.ok){
//   console.log("get_products_netlify_serverless", data)
//   setAllProducts(data)  
//   setXataData(data)

// }
   }
   getProducts();
  }, [searchTearm]);


  
  return (
    <main>
      <section className="my-5 items-center mx-auto max-w-screen-xl">
        <div className="my-5 flex justify-between ">
          <span className="  text-2xl font-semibold dark:text-slate-100 mb-5">
            All Books ({allProducts.length})
          </span>
          <span>
            <button
              id="dropdownMenuIconButton"
              data-dropdown-toggle="dropdownDots"
              className="inline-flex items-center p-2 text-sm font-medium text-center text-gray-900 bg-gray-100 rounded-lg hover:bg-gray-200 dark:text-white dark:bg-gray-600 dark:hover:bg-gray-700"
              onClick={() => setShow(!show)}
            >
              <svg
                className="w-6 h-6"
                aria-hidden="true"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"></path>
              </svg>
            </button>
          </span>
        </div>
        <div>
          <div className="flex flex-wrap justify-center lg:flex-row ">
            {/* {xataData.map((item, index)=>{ */}
            {CmsData.map((item, index)=>{
               return ( 
                 <ProductCard key={index} data={item} /> 
               ) 
             })} 
          </div>
        </div>
      </section>
      {/* {show && <FilterBar setShow={setShow} />} */}
    </main>
  );
};
